import React, { useEffect, useState } from "react";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import { BtnExportExcel } from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { FormProvider, useForm } from "react-hook-form";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { TextBoxItem } from "components/Input/TextBox";
import { GetMenuPermission } from "utilities/SystemFunction";
import moment from "moment";

const ReportParcel = () => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });
    const formEquipment = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
        form.setValue("sChairman", "นายปฏิพล ดลรุ้ง");
        form.setValue("sDirectorOne", "นายปารเมศ คำฟู");
        form.setValue("sDirectorTwo", "นายนัทวิชญ์ คุ้มวิจัยรัตน์");
    }, []);

    const handdleExportMaterialReport = () => {
        DialogFn.BlockUI();

        let param = {
            nYear: form.getValues("dMaterial") ? form.getValues("dMaterial").valueOf() : null,
            sChairman: form.getValues("sChairman"),
            sDirectorOne: form.getValues("sDirectorOne"),
            sDirectorTwo: form.getValues("sDirectorTwo"),
        }
        let nThaiYear = moment(formEquipment.getValues("dMaterial")).format("yyyy");
        let sFileName = `รายงานบัญชีวัสดุ (ประจำปี ${+nThaiYear + 543}).xlsx`
        AxiosFn.DowloadFileBlob(`ReportParcel/onExportMaterialReport`, param, sFileName, (result) => {
            DialogFn.UnBlockUI();
        });
    }

    const handdleExportEquipmentReport = () => {
        DialogFn.BlockUI();
        let param = {
            nYear: formEquipment.getValues("dEquipment") ? formEquipment.getValues("dEquipment").valueOf() : null,
        }
        let nThaiYear = moment(formEquipment.getValues("dEquipment")).format("yyyy");
        let sFileName = `รายงานครุภัณฑ์ ประจำปี ${+nThaiYear + 543}(ค่าเสื่อมสรุป สตง ปีละครั้ง).xlsx`
        AxiosFn.DowloadFileBlob(`ReportParcel/onExportEquipmentReport`, param, sFileName, (result) => {
            DialogFn.UnBlockUI();
        });
    }

    return (
        <React.Fragment>
            <FormProvider {...form}>
                {/* รายงานวัสดุ */}
                <Typography style={{ fontSize: 18, fontWeight: 600, color: "#0056b3" }}>
                    {`${I18n.SetText("ReportParcel.ReportMaterial")}`}
                </Typography>
                <Divider textAlign="left" style={{ fontSize: 18}}>{`${I18n.SetText("ReportParcel.ReportYear")}`}</Divider>
                <Stack direction={"row"} sx={{ mt: "2%", mb: "4%", mx: "4%" }}>
                    <Grid container spacing={2}>
                        <Grid item md={2.8} xs={12}>
                            <DatePickerItem
                                name={`dMaterial`}
                                id={`dMaterial`}
                                label={`${I18n.SetText("ReportParcel.sYear")}`}
                                IsYearPicker
                                required={true}
                                disabled={false}
                                fullWidth
                                maxDate={moment()}
                            />
                        </Grid>
                        <Grid item md={2.8} xs={12}>
                            <TextBoxItem
                                required={true}
                                label={`${I18n.SetText("ReportParcel.sChairman")}`}
                                id={'sChairman'}
                                name={'sChairman'}
                                maxLength={250}
                                type={'text'}
                                IsShowMessageError
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item md={2.8} xs={12}>
                            <TextBoxItem
                                required={true}
                                label={`${I18n.SetText("ReportParcel.sDirector")}`}
                                id={'sDirectorOne'}
                                name={'sDirectorOne'}
                                maxLength={250}
                                type={'text'}
                                IsShowMessageError
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item md={2.8} xs={12}>
                            <TextBoxItem
                                required={true}
                                label={`${I18n.SetText("ReportParcel.sDirector")}`}
                                id={'sDirectorTwo'}
                                name={'sDirectorTwo'}
                                maxLength={250}
                                type={'text'}
                                IsShowMessageError
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item md={0.6} xs={12}>
                            <BtnExportExcel id={"expSummaryReport"}
                                onClick={form.handleSubmit((e) => { handdleExportMaterialReport() })}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </FormProvider>

            <FormProvider {...formEquipment}>
                {/* รายงานครุภัณฑ์ */}
                <Typography style={{ fontSize: 18, fontWeight: 600, color: "#0056b3" }}>
                    {`${I18n.SetText("ReportParcel.sReportEquipment")}`}
                </Typography>
                <Divider textAlign="left" style={{ fontSize: 18}}>{`${I18n.SetText("ReportParcel.sReportEquipmentYear")}`}</Divider>
                <Stack direction={"row"} sx={{ mt: "2%", mb: "4%", mx: "4%" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <DatePickerItem
                                name={`dEquipment`}
                                id={`dEquipment`}
                                label={`${I18n.SetText("ReportParcel.sYear")}`}
                                IsYearPicker
                                required={true}
                                disabled={false}
                                fullWidth
                                maxDate={moment()}
                            />
                        </Grid>
                        <Grid item>
                            <BtnExportExcel id={"expIncomeExpense"}
                                onClick={formEquipment.handleSubmit((e) => { handdleExportEquipmentReport() })}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </FormProvider>
        </React.Fragment >
    );
}

export default ReportParcel